import { createAction } from '@reduxjs/toolkit';
import { type RequestActionCreator } from '@/types';

export const makeActionCreator =
  (prefix: string) =>
  <P = void>(action: string) =>
    createAction<P>(`${prefix}/${action}`);

export const makeRequestActionCreator =
  (prefix: string) =>
  <P = void, S = void>(action: string) => {
    const actionCreator = createAction<P>(
      `${prefix}/${action}`,
    ) as RequestActionCreator<P, S>;

    actionCreator.succeeded = createAction<S>(`${prefix}/${action}/succeeded`);
    actionCreator.failed = createAction<string>(`${prefix}/${action}/failed`);

    return actionCreator;
  };
